<template>
	<list
		v-bind:title="'Search results for “' + readableSearchTerms + '”'"
		v-bind:readerId="0"
		v-bind:search="true"
	>
		<p v-if="searchResults == '' || searchResults == 'undefined' || searchResults == null">There are no results matching “{{ readableSearchTerms }}.”</p>
		<div v-else v-for="book in searchResults" :key="book.book_id" class="search-result">
			<router-link class="cover" :to="{path:'/book/' + book.book_id}" v-bind:style="{ backgroundImage: 'url(' + book.cover_url + ')' }">"{{ book.title }}" book cover</router-link>
			<span>
				<h2><router-link :to="{path:'/book/' + book.book_id}">{{ book.title }}</router-link></h2>
				<p>By <template v-for="author in book.authors"><router-link :key="author.name" :to="{path:'/author/' + author.author_id}">{{ author.name }}</router-link>, </template>{{ book.year }}</p>
				<div class="search-buttons">
					<button data-tooltip="Mark as read" id="read-btn" v-on:click="addToList('read')" class="eye icon" :class="readState">{{ readState == "selected" ? 'Unmark as Read' : 'Mark as read'}}</button>
					<button data-tooltip="Like book" id="liked-btn" v-on:click="addToList('liked')" class="heart icon" :class="likedState">{{ likedState == "selected" ? 'Unlike book' : 'Like book'}}</button>
					<button data-tooltip="Add To-Read" id="to-read-btn-little" v-on:click="addToList('to_read')" class="add icon little" :class="toReadState">{{ toReadState == "selected" ? 'Take Off To-Read' : 'Add To-Read' }}</button>
					<button data-tooltip="Add To Library" id="library-btn-little" v-on:click="addToList('library')" class="library icon little" :class="libraryState">{{ libraryState == "selected" ? 'Remove From Library' : 'Add To Library'}}</button>
					
					<button id="to-read-btn" v-on:click="addToList('to_read')" :class="toReadState">{{ toReadState == "selected" ? 'Take Off To-Read' : 'Add To-Read' }}</button>
					<button id="library-btn" v-on:click="addToList('library')" :class="libraryState">{{ libraryState == "selected" ? 'Remove From Library' : 'Add To Library'}}</button>
				</div>
			</span>
		</div>
		<!-- <div style="
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		grid-column: 1 / -1;
		text-align: center;
		place-items: center;
		margin-bottom: 60px;
		">
			<button style="justify-self: left; margin-right: 0;" class="look-like-link">⇦ Previous</button>
			<button style="cursor: default; margin-right: 0;" class="look-like-link">Page 1</button>
			<button style="justify-self: right; margin-right: 0;" class="look-like-link">More ⇨</button>
			</div> -->
	</list>
</template>

<script>
	import List from '../layout/List.vue'

	export default
	{
		components: 
		{
			List
		},
		created ()
		{
			document.title = 'Search results for "' + this.$route.params.keywords.replace(/[+-]/g, ' ') + '" | Bookplate';
		},
		data () 
		{
			return {
				results: ""
			}
		},
		mounted () 
		{
			try 
			{
				fetch('https://api.bookplate.co/search/books/' + this.searchTerms + '?page=' + this.pageNumber,
				{
					credentials: 'include'
				})
				.then(function(response)
				{
					if(response.status != 200)
					{
						throw response.status;
					}

					return response.json();
				})
				.then(json => this.results = json)
			}
			catch(e)
			{
				this.$alert("Something went wrong. Please try again in a moment, or contact support@bookplate.co. Error:" + e, "An error occured");
			}
		},
		computed: 
		{
			pageNumber: function()
			{
				if(this.$route.query.page == null)
				{
					return 1;
				}
				
				return this.$route.query.page;
			},
			searchTerms: function() 
			{
				return this.$route.params.keywords;
			},
			readableSearchTerms: function()
			{
				return this.$route.params.keywords.replace(/[+-]/g, ' ');
			},
			searchResults: function()
			{
				return this.results;
			}
		},        
	}
</script>